import { render, staticRenderFns } from "./dev-param-result.vue?vue&type=template&id=2af65f65&scoped=true&"
import script from "./dev-param-result.vue?vue&type=script&lang=js&"
export * from "./dev-param-result.vue?vue&type=script&lang=js&"
import style0 from "./dev-param-result.vue?vue&type=style&index=0&id=2af65f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af65f65",
  null
  
)

export default component.exports